import Vue from 'vue'
import App from './App.vue'
import router from '@/router/router.js'
import store from '@/store/index.js'
import vuetify from '@/plugins/vuetify.js'
import Toasted from 'vue-toasted'
import '@/api/index.js'
import '@/plugins/veeValidate.js'
import '@/scss/global.scss'
import { showError } from '@/utils/notification.js'

Vue.config.productionTip = false
Vue.use(Toasted)

Vue.config.errorHandler = message => {
  showError('Something went wrong, please try again.')
  console.log(message) //do not delete
}

window.app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
